import { render } from "./InitialDeposit.vue?vue&type=template&id=dc74f300&scoped=true"
import script from "./InitialDeposit.vue?vue&type=script&lang=js"
export * from "./InitialDeposit.vue?vue&type=script&lang=js"

import "./InitialDeposit.vue?vue&type=style&index=0&id=dc74f300&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc74f300"]])

export default __exports__